module.exports = __webpack_public_path__ + "static/media/video2.227b174.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/components/quienes-somos/video2.mp4
// module id = hB+3
// module chunks = 0